import { ToastIconColorTypeCss } from './types';

export const TOAST_ICON_COLOR_TYPE_CSS: ToastIconColorTypeCss = {
  default: '',
  success: 'fill-green-500',
  caution: 'fill-orange-500',
  error: 'fill-red-500'
};
